import React from 'react';

import { colors } from '@styleseat/brand';
import NotificationBanner from '../NotificationBanner';
import { VariousSparklesIcon } from '../../../ui/Icons';

export type NotificationProps = {
  type: 'ncd_appointment_paid_on_styleseat';
  object_type: 'Appointment';
  appointment_id: string | number;
  provider_id: string | number;
  creation_time: string;
};

type NcdPaymentAppointmentNotificationProps = {
  onCTAClick: () => void;
  notification: NotificationProps;
  clientName: string;
};

const NcdPaymentAppointmentNotification: React.FC<NcdPaymentAppointmentNotificationProps> = ({
  onCTAClick,
  notification,
  clientName,
}) => (
  <NotificationBanner
    icon={VariousSparklesIcon}
    notification={notification}
    iconColor={colors.sunshine}
    buttonProps={{
      text: 'See Current Score',
      size: 'small',
      appearance: 'outline',
      onClick: onCTAClick,
    }}
    highlightedText="Great job!"
    text={`You checked out ${clientName} on StyleSeat, making you one step closer to achieving Top Pro status.`}
  />
);

export default NcdPaymentAppointmentNotification;
